var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 0.666748C2.44928 0.666748 1.60143 1.01794 0.976311 1.64306C0.351189 2.26818 0 3.11603 0 4.00008V4.33508L10 9.72008L20 4.33675V4.00008C20 3.11603 19.6488 2.26818 19.0237 1.64306C18.3986 1.01794 17.5507 0.666748 16.6667 0.666748H3.33333ZM20 6.22841L10.395 11.4001C10.2736 11.4654 10.1379 11.4996 10 11.4996C9.86212 11.4996 9.7264 11.4654 9.605 11.4001L0 6.22841V14.0001C0 14.8841 0.351189 15.732 0.976311 16.3571C1.60143 16.9822 2.44928 17.3334 3.33333 17.3334H16.6667C17.5507 17.3334 18.3986 16.9822 19.0237 16.3571C19.6488 15.732 20 14.8841 20 14.0001V6.22841Z",
    fill: "#787E8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.220c49af6a97ed2e6e542ad6c807a450.svg";
export { ForwardRef as ReactComponent };